<template>
  <b-modal
    id="availableinvoice"
    size="lg"
    ref="availableinvoice"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Apply Invoice':'Apply Invoice'"
    :title="title"
    :no-close-on-backdrop="true"
    @shown="createFreshObject()"
    @ok.prevent="onSubmit()"
    :lazy="true"
  >
  <b-alert  class="alert-transparent alert-danger" v-if="error_msg">
    <p>{{error_msg}}</p>
  </b-alert>
    <b-alert
      class="alert-transparent alert-danger"
      :show="alertShow= error_show && this.errors.any()"
    >
      <button type="button" @click="error_show = false" class="close">
        <span aria-hidden="true">&times;</span>
      </button>

      <p
        class="text-danger"
        v-if="errors.has('paid_amount')"
      >Please enter the valid amount to be applied to invoice(s).</p>
    </b-alert>
    <span class="text-bold float-right">
      <strong>{{ currency+parseFloat(field.unused_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</strong>
    </span>
    <span class="text-bold float-right mr-2">
      <strong>Balance :</strong>
    </span>
    <br />
    <!--  table for showing availabel credit details -->
    <div class="table-responsive mt-4">
      <table class="table table-hover">
        <thead>
          <th>INVOICE NUMBER</th>
          <th>INVOICE DATE</th>
          <th class="text-right">INVOICE AMOUNT</th>
          <th class="text-right">INVOICE BALANCE</th>
          <th class="text-right">AMOUNT</th>
          <th></th>
        </thead>
        <template v-if="items.length == 0">
          <tbody>
            <tr>
              <td colspan="6" class="text-center">No data to display</td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <tbody>
            <tr v-for="(item,index) in items" :key="item.id">
              <td>{{ item.inv_no }}</td>
              <td>{{ getDateFormat(item.created_date) }}</td>
              <td
                class="text-right"
              >{{ currency+parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
              <td
                class="text-right"
              >{{ currency+parseFloat(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
              <td>
                <input
                  type="text"
                  class="form-control text-right"
                  v-model.trim="item.used_amount"
                  @blur="total(),checkAdvance(index)"
                />
              </td>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="text-right">Amount:</td>
              <td class="text-right">{{ currency+header.paid_amount }}</td>
            </tr>
            <tr>
              <td colspan="4" class="text-right" style="border-top:none">Amount Available:</td>
              <td
                class="text-right"
                style="border-top:none"
              >{{ currency+field.apply_unused_amount }}</td>
            </tr>
          </tfoot>
        </template>
      </table>
      <input
        type="hidden"
        name="paid_amount"
        :value="header.paid_amount"
        v-validate="'required|between:0,'+field.unused_amount+'|excluded:'+parseFloat(0).toFixed(2)+'|max_value:'+parseFloat(field.unused_amount).toFixed(2)"
      />
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";

import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component

export default {
  props: [
    "field",
    "title",
    "submit",
    "check",
    "page",
    "currency",
    "place_of_supply"
  ], // field data form parent component
  mixins: [notificationMixin], // for showing message notification
  data() {
    return {
      error_msg:'',
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      checkCustomerAdvance: {},
      header: {
        paid_amount: "0.00"
      },
      alertShow: "", // to show the error message
      error_show: false, // to show the error message
      items: [], // credit available details
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    checkAdvance(i) {
      if (
        this.items[i].pymnt_type == 4 &&
        this.items[i].place_of_supply != this.place_of_supply &&
        this.items[i].used_amount > 0
      ) {
        this.checkCustomerAdvance[i] = 1;
      } else {
        delete this.checkCustomerAdvance[i];
      }
    },
    // calculation for using credit amount for tallyign invoice
    total() {
      var header_unused_amount = parseFloat(this.field.unused_amount);
      var header_amount = this.items.reduce(function(total, value) {
        var available_amount = parseFloat(value.due_amount);
        var used_amount = parseFloat(value.used_amount);
        if (
          used_amount > available_amount ||
          used_amount > header_unused_amount
        ) {
          value.used_amount =
            header_unused_amount <= available_amount
              ? header_unused_amount
              : available_amount;
        }
        header_unused_amount -= value.used_amount;
        return !isNaN(parseFloat(value.used_amount))
          ? total + parseFloat(value.used_amount)
          : parseFloat(total);
      }, 0);
      this.header.paid_amount = header_amount.toFixed(2);
      var unused_amount =
        parseFloat(this.field.unused_amount) - parseFloat(header_amount);
      this.field.apply_unused_amount = unused_amount.toFixed(2);
    },
    createFreshObject() {
      this.header.paid_amount = "0.00";
      this.field.apply_unused_amount = parseFloat(
        this.field.unused_amount
      ).toFixed(2);
    },
    invoicedetails() {
      store
        .dispatch(
          "general/" + this.check,
          JSON.stringify({ id: this.$route.params.id })
        )
        .then(() => {
         if(this.status_code==200){
          this.items = this.invoice_details;
          }else{
        this.$emit("checkCustomer",{status_message:this.status_message,status_type:this.status_type})
          }
        });
    },
    onSubmit() {
      if (Object.entries(this.checkCustomerAdvance).length > 0) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message:
            "Cannot apply Customer Payment to Invoice, Since it has different Place Of Supply.",
          type: "danger",
          showCloseButton: true
        });
        return;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.error_msg='';
          this.submitted = true;
           var message;
          this.$refs.availableinvoice.hide();
          var data = JSON.stringify({
            id: this.$route.params.id,
            field: {
              id: this.field.id,
              paid_amount: this.header.paid_amount,
              unused_amount: this.field.apply_unused_amount
            },
            items: this.items
          });
          store.dispatch("general/" + this.submit, data).then(() => {
            this.submitted = false;
            // //  update the page details and field detials
            if(this.$store.state.general.status_code==200){
              this.error_msg='';
            if (this.page == "retainer") {
              this.retainer_invoice_details_payment = this.retainer_credit_invoice_details.invoice_details_payment; // update invoice details of retainer
              this.retainer_header_details = this.retainer_credit_invoice_details.header_details; // update amount and status details of retainer
                message = "Customer deposit have been applied to the invoices";
            }
            if (this.page == "credit") {
              this.credit_invoice_details_payment = this.retainer_credit_invoice_details.invoice_details_payment; // update invoice details of retainer
              this.credit_header_details = this.retainer_credit_invoice_details.header_details; // update amount and status details of retainer
              message = "Credits have been applied to the invoices";
            }
            if (this.page == "customeradvance") {
              this.customer_advance_invoice_details_payment = this.retainer_credit_invoice_details.invoice_details_payment; // update invoice details of retainer
              this.customer_advance_header_details = this.retainer_credit_invoice_details.header_details; // update amount and status details of retainer
                message = "Customer advance have been applied to the invoices";
            }
             window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: "success",
              showCloseButton: true
            });
            }else{
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
              this.error_msg= this.status_message
            }
            
          });
        } else {
          this.error_show = true; // show validation message
          this.error_msg='';
        }
      });
    }
  },
  mounted() {
    EventBus.$on("invoicedetails", this.invoicedetails); // to trigger the method from parentcomponent
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      invoice_details: state => state.general.customer_invoice_details,
      retainer_credit_invoice_details: state =>
        state.general.retainer_credit_invoice_details,
      status_code: state => state.general.status_code,
      status_message: state => state.general.status_message,
      status_type: state => state.general.status_type
    }),
    //  to update applied credit amount in the invoice page
    retainer_invoice_details_payment: {
      get() {
        return this.$store.state.retainer.list.invoice_details_payment;
      },
      set(val) {
        this.$store.state.retainer.list.invoice_details_payment = val;
      }
    },
    //  to update applied credit amount in the invoice page
    retainer_header_details: {
      get() {
        return this.$store.state.retainer.list.header_details;
      },
      set(val) {
        this.$store.state.retainer.list.header_details = val;
      }
    },
    //  to update applied credit amount in the invoice page
    credit_invoice_details_payment: {
      get() {
        return this.$store.state.credit.list.invoice_details_payment;
      },
      set(val) {
        this.$store.state.credit.list.invoice_details_payment = val;
      }
    },
    //  to update applied credit amount in the invoice page
    credit_header_details: {
      get() {
        return this.$store.state.credit.list.header_details;
      },
      set(val) {
        this.$store.state.credit.list.header_details = val;
      }
    },
    //  to update applied customer advance amount in the invoice page
    customer_advance_invoice_details_payment: {
      get() {
        return this.$store.state.customeradvance.list.data
          .invoice_details_payment;
      },
      set(val) {
        this.$store.state.customeradvance.list.data.invoice_details_payment = val;
      }
    },
    //  to update applied credit amount in the invoice page
    customer_advance_header_details: {
      get() {
        return this.$store.state.customeradvance.list.data.header_details;
      },
      set(val) {
        this.$store.state.customeradvance.list.data.header_details = val;
      }
    }
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>